import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { Html5Qrcode } from "html5-qrcode";

export function useQRCodeScan({
  qrcodeMountNodeID = "",
  closeAfterScan = true,
  getQrBoxDimension,
}) {
  const [decodedQRData, setDecodedQrData] = useState({
    isScanning: false,
    isScanSuccess: false,
    isScanFailure: false,
    data: null,
    error: "",
  });
  const html5QrCodeScannerRef = React.useRef(null);

  // unmount logic
  useEffect(() => {
    return () => {
      if (html5QrCodeScannerRef.current) {
        html5QrCodeScannerRef.current
          ?.stop()
          ?.then((ignore) => {
            // QR Code scanning is stopped
            setDecodedQrData({
              isScanning: false,
              isScanSuccess: false,
              isScanFailure: false,
              data: null,
              error: "",
            });
            console.log("stopped after successful scan");
          })
          ?.catch((err) => {
            // Stop failed, handle it.
            alert("fails to stop after successfull scan result");
          });
      }
    };
  }, []);

  function stopQrCode() {
    if (html5QrCodeScannerRef.current) {
      html5QrCodeScannerRef.current
        ?.stop()
        ?.then((ignore) => {
          // QR Code scanning is stopped

          console.log("stopped after successful scan");
        })
        ?.catch((err) => {
          // Stop failed, handle it.
          console.log("fails to stop after successfull scan result ");
        });
    }
  }
  function startQrCode() {
    try {
      setDecodedQrData({
        ...decodedQRData,
        isScanning: true,
        data: null,
      });
      // eslint-disable-next-line
      const html5qrCodeScanner = new Html5Qrcode(qrcodeMountNodeID);

      Html5Qrcode.getCameras()
        .then((devices) => {
          /**
           * devices would be an array of objects of type:
           * { id: "id", label: "label" }
           */
          if (devices && devices.length) {
            var cameraId = devices[0].id;
            console.log(cameraId);
            // .. use this to start scanning.
          }

          html5QrCodeScannerRef.current = html5qrCodeScanner;

          let qrbox = 250;
          if (getQrBoxDimension) {
            qrbox = getQrBoxDimension();
          }

          html5qrCodeScanner
            .start(
              // { deviceId: { exact: cameraId } },
              { facingMode: "environment" },

              { fps: 60, qrbox, aspectRatio: 1.777778 },
              (qrCodeMessage) => {
                // do something when code is read
                // console.log('scanned qr code', qrCodeMessage);

                setDecodedQrData({
                  ...decodedQRData,
                  isScanSuccess: true,
                  isScanning: false,
                  data: qrCodeMessage,
                  error: "",
                });

                if (closeAfterScan) {
                  html5qrCodeScanner
                    .stop()
                    .then((ignore) => {
                      // QR Code scanning is stopped.
                      // setIsOpenCamera(false);
                      setDecodedQrData({
                        isScanning: false,
                        isScanSuccess: false,
                        isScanFailure: false,
                        data: null,
                        error: "",
                      });
                      console.log("stopped after successful scan2");
                    })
                    .catch((err) => {
                      // Stop failed, handle it.
                      console.log(
                        "fails to stop after succesfull scan result "
                      );
                    });
                }
              },
              (errorMessage) => {}
            )
            .catch((err) => {
              alert(`cannot open scanner, ${JSON.stringify(err)}`);
              setDecodedQrData({
                ...decodedQRData,
                isScanSuccess: false,
                isScanning: false,
                isScanFailure: true,
                data: null,
                error: err || "QR Code parsing failed",
              });
            });
        })
        .catch((err) => {
          alert(`camera not working, ${JSON.stringify(err)}`);
        });
    } catch (e) {
      alert(`cannot start qr code, ${JSON.stringify(e)}`);
      setDecodedQrData({
        ...decodedQRData,
        isScanSuccess: false,
        isScanning: false,
        isScanFailure: true,
        data: null,
        error: e || "QR Code parsing failed",
      });
    }
  }

  return {
    startQrCode,
    decodedQRData,
    stopQrCode,
  };
}
